import { useLocation, useNavigate } from "react-router-dom";

export default function BookingConfirmed() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const method = state?.method; // "invoice" | "credits"

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg
            width='40'
            height='40'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#E05A3A'
            strokeWidth='2.5'
            aria-hidden='true'>
            <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
            <polyline points='22 4 12 14.01 9 11.01' />
          </svg>
        </div>

        <h1 style={styles.title}>Bestilling bekreftet!</h1>

        {method === "invoice" && (
          <p style={styles.sub}>
            Promotering av arrangementet ditt er nå aktivt. Bestillingen er lagt
            til din månedlige faktura som sendes ved månedsslutt.
          </p>
        )}

        {method === "credits" && (
          <p style={styles.sub}>
            Promotering av arrangementet ditt er nå aktivt. Beløpet er trukket
            fra din kredittbalanse.
          </p>
        )}

        {!method && (
          <p style={styles.sub}>
            Promotering av arrangementet ditt er nå aktivt.
          </p>
        )}

        <button
          style={styles.btn}
          onClick={() => navigate("/MyBusiness/events")}>
          Tilbake til forsiden
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f7f5f0",
    padding: "1rem",
    fontFamily: "'DM Sans', sans-serif",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "2.5rem 2rem",
    maxWidth: "420px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
  },
  iconWrap: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    background: "#fef3ee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1.5rem",
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: "0 0 0.75rem",
  },
  sub: {
    fontSize: "15px",
    color: "#666",
    lineHeight: 1.6,
    margin: "0 0 1.75rem",
  },
  btn: {
    background: "#E05A3A",
    color: "#fff",
    border: "none",
    borderRadius: "30px",
    padding: "12px 32px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
  },
};
